import * as React from 'react';
import {autoprefixer} from "diy/material-ui/autoprefixer";

export interface ToolbarContentProps {

}

interface ToolbarContentState {

}

export class ToolbarContent extends React.Component<ToolbarContentProps, ToolbarContentState> {
    render() {
        return (
            <div style={autoprefixer({
                padding: "4px 11px",
                display: 'flex'
            })}>
                {this.props.children}
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/toolbar/ToolbarContent.tsx
 **/